import React from 'react';
import { Button, Modal, ModalProps } from 'react-bootstrap';
import { createModal } from 'react-modal-promise';
import { FieldDatepicker, FieldInput, FormCard, FormCol6, FormRow } from 'motion-components';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

type ReceptionFormValues = {
  dateStorage: Date;
  receptionNetWeight: number | string;
};

type Props = {
  readonly open: boolean;
  readonly close: (result: ReceptionFormValues | false) => void;
  readonly idoc: {
    id: number;
    identificationDocument?: string;
    netWeight?: number;
    receptionNetWeight?: number;
  };
  readonly defaultDateStorage?: Date;
} & ModalProps;

const validationSchema = Yup.object({
  dateStorage: Yup.date().required('Η ημερομηνία παραλαβής είναι υποχρεωτική'),
  receptionNetWeight: Yup.number()
    .typeError('Το βάρος πρέπει να είναι αριθμός')
    .required('Το βάρος είναι υποχρεωτικό')
    .min(0, 'Το βάρος δεν μπορεί να είναι αρνητικό'),
});

const ModalReception = ({ open, close, idoc, defaultDateStorage }: Props) => {
  const { t } = useTranslation();
  const initialWeight = idoc.receptionNetWeight ?? idoc.netWeight ?? '';

  return (
    <Modal size="lg" show={open} centered backdrop="static" onHide={() => close(false)}>
      <FormCard
        title={t('Να γίνει Παραλαβή Αποβλήτων')}
        initialValues={{
          dateStorage: defaultDateStorage ?? new Date(),
          receptionNetWeight: initialWeight,
        }}
        validationSchema={validationSchema}
        onSubmit={(values: ReceptionFormValues) => close(values)}
        noButtons={true}
        injectFooterElements={() => (
          <div className="d-flex gap-3">
            <Button variant="danger" onClick={() => close(false)}>
              {t('Άκυρο')}
            </Button>
            <Button variant="primary" type="submit">
              OK
            </Button>
          </div>
        )}
      >
        <p className="mb-3">
          {t('Να γίνει Παραλαβή Αποβλήτων με Αριθμό Εντύπου Αναγνώρισης')}:{' '}
          <strong>{idoc.identificationDocument}</strong>;
        </p>
        <FormRow>
          <FieldDatepicker
            as={FormCol6}
            required
            label={t('Ημ/νία Παραλαβής')}
            name="dateStorage"
            hasMask={true}
            placeholder="dd/mm/yyyy HH:mm"
            showTimeSelect
            dateFormat="d/M/yyyy HH:mm"
            timeFormat="HH:mm"
            timeIntervals={15}
          />
          <FieldInput
            as={FormCol6}
            required
            label={t('Βάρος σε κιλά')}
            name="receptionNetWeight"
            type="number"
          />
        </FormRow>
      </FormCard>
    </Modal>
  );
};

export const promiseModalIdocReception = createModal(ModalReception);
